export default "/assets/images/screen-03.d29e834791633651.png";